import { Module } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import { usePermissions } from "@/modules/account/hooks/usePermissions";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { type NavigationAnchor } from "@/components/layout/types";

export const useDictionariesMenuItems = (): NavigationAnchor[] => {
  const { t } = useTranslation();
  const permissions = usePermissions();

  return useMemo(
    () =>
      Object.values(Module)
        .map((dict) => getDictionaryConfig(dict))
        .filter((config) => config !== undefined)
        .filter((config) => !config.excludeFromDefaultMenu)
        .map((config) => {
          return {
            icon: config.Icon,
            url: config.path,
            title: config.getLabels(t).dict,
            permission: permissions[config.id].can_read,
          };
        }),
    [permissions, t],
  );
};
